import { render, staticRenderFns } from "./EditMedia.vue?vue&type=template&id=f533128e&scoped=true&"
import script from "./EditMedia.vue?vue&type=script&lang=js&"
export * from "./EditMedia.vue?vue&type=script&lang=js&"
import style0 from "./EditMedia.vue?vue&type=style&index=0&id=f533128e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f533128e",
  null
  
)

export default component.exports